export const queryParser = (str) => {
  const cutStr = str.slice(1);
  const coupleStr = cutStr.split('&').map((item) => item.split('='));

  return coupleStr.reduce(
    (acc, [key, value]) => ({
      ...acc,
      [decodeURIComponent(key).replace(/[ +]/g, '_')]:
        decodeURIComponent(value),
    }),
    {}
  );
};

export const concatClickID = (a = '', b = '', c = '', d = '') => {
  const currUrl = document.location.href;
  const encodedUrl = encodeURIComponent(currUrl);
  const params = [a, b, c, encodedUrl, d];

  return params.filter((p) => typeof p === 'string' && p.length > 0).join(';');
};
